import { Auth, API } from "aws-amplify";

class Service {
  static methods = {
    get: "GET",
    post: "POST",
    put: "PUT",
    del: "DELETE",
  };

  static get(endpoint, path, options = null) {
    return Service.execute("get", endpoint, path, options);
  }

  static post(endpoint, path, options = null) {
    return Service.execute("post", endpoint, path, options);
  }

  static put(endpoint, path, options = null) {
    return Service.execute("put", endpoint, path, options);
  }

  static del(endpoint, path, options = null) {
    return Service.execute("del", endpoint, path, options);
  }

  static execute(action, endpoint, path, options = null) {
    return Service.executeAPI(action, endpoint, path, options);
  }

  static executeAPI(action, endpoint, path, options = null) {
    return new Promise((resolve, reject) => {
      Auth.currentSession()
        .then((currentSession) => {
          const token = currentSession.getIdToken().getJwtToken();
          const apiOptions = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            ...options,
          };
          API[action](endpoint, path, apiOptions)
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default Service;
